export default __webpack_public_path__ + "static/cafe_36073-990251b60b48b2432b299eb43f53b7d6.png";